import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import type {CSSProperties} from "react";
import {Button} from "reactstrap";
import {
  RESOLVED_CARD_TINT,
  RESOLVED_ICON_TINT,
  STATUS_CARD_BASE_STYLE,
  STATUS_ICON_BASE_STYLE,
  STATUS_TITLE_STYLE,
} from "./statusCardStyles.js";

type Props = {
  onRemovePin: () => void;
};

/**
 * État `isManualFrozen` (#929) : position posée à la main, texte inchangé
 * depuis — un doute levé par une source différente de l'IGN (pin vs
 * géocodage), d'où la teinte action apaisée (`RESOLVED_CARD_TINT`). Pas de
 * libellé IGN : la position vient de l'utilisateur, pas du géocodeur.
 */
export function ManualPinFrozen({onRemovePin}: Props) {
  return (
    <div style={{...STATUS_CARD_BASE_STYLE, ...RESOLVED_CARD_TINT}}>
      <div style={{display: "flex", alignItems: "flex-start", gap: "10px"}}>
        <span style={{...STATUS_ICON_BASE_STYLE, ...RESOLVED_ICON_TINT}}>
          <FontAwesomeIcon icon="map-marker-alt" />
        </span>
        <div style={{minWidth: 0}}>
          <div style={STATUS_TITLE_STYLE}>
            Point placé manuellement
            <span style={MANUAL_TAG_STYLE}>manuel</span>
          </div>
          <div style={{fontSize: "12px", color: "#6c757d"}}>
            Repère positionné à la main — remplace la position IGN
          </div>
        </div>
      </div>
      <div style={{paddingLeft: "36px"}}>
        <Button color="primary" outline size="sm" type="button" onClick={handleRemovePinClick}>
          Retirer le repère
        </Button>
      </div>
    </div>
  );

  function handleRemovePinClick() {
    onRemovePin();
  }
}

const MANUAL_TAG_STYLE: CSSProperties = {
  fontSize: "9px",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.03em",
  background: "rgba(var(--mt-color-action-rgb), 0.14)",
  color: "var(--mt-color-action)",
  padding: "1px 6px",
  borderRadius: "8px",
  marginLeft: "6px",
};
